const verifierKey = 'dealbox_cognito_pkce_verifier';

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function getCognitoRedirectUri(): string {
  return (import.meta as any).env.VITE_COGNITO_REDIRECT_URI || `${window.location.origin}/auth/callback`;
}

export async function createPkceChallenge(): Promise<{ verifier: string; challenge: string }> {
  const random = new Uint8Array(64);
  crypto.getRandomValues(random);
  const verifier = base64UrlEncode(random);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const challenge = base64UrlEncode(new Uint8Array(digest));
  sessionStorage.setItem(verifierKey, verifier);
  return { verifier, challenge };
}

export function consumePkceVerifier(): string | null {
  const verifier = sessionStorage.getItem(verifierKey);
  sessionStorage.removeItem(verifierKey);
  return verifier;
}
